var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#FDF0DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5897_10596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7249 24.7797C27.7249 21.7521 28.2816 19.099 29.2058 17.2061C23.7731 20.3277 19.0092 20.5271 16.619 20.6711C15.275 20.7521 14.0375 21.6267 13.394 22.9963C12.8696 24.1128 12.8727 25.4288 13.3794 26.5532C14.018 27.9705 15.2627 28.8998 16.6189 28.8881C16.8435 28.8862 17.1123 28.8896 17.4113 28.8997C16.9271 31.0788 18.1753 33.384 20.4201 34.3568C21.1062 34.6542 21.8295 34.8036 22.5466 34.8036C23.1054 34.8036 23.6606 34.7128 24.1909 34.5297C25.4172 34.1068 26.3652 33.2445 26.8601 32.1025C26.9753 31.8368 27.0534 31.5586 27.113 31.2763C27.8003 31.5938 28.5001 31.9513 29.2078 32.3571C28.2825 30.4639 27.7249 27.8095 27.7249 24.7797ZM25.9427 31.7049C25.5606 32.5863 24.8228 33.2537 23.8648 33.5844C22.8909 33.9203 21.8084 33.8685 20.8177 33.4388C18.9601 32.634 17.9435 30.7189 18.4244 28.9597C20.3332 29.1146 23.0903 29.5792 26.1794 30.8655C26.1373 31.1542 26.059 31.4364 25.9427 31.7049Z",
    fill: "#FF882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8622 15.1965C31.2085 15.1965 29.7855 17.4491 29.1231 20.6969C31.3315 20.7495 33.1128 22.5589 33.1128 24.7798C33.1128 27.0006 31.3314 28.8096 29.123 28.8622C29.7854 32.1101 31.2084 34.3628 32.8622 34.3628C35.1474 34.3628 36.9998 30.0722 36.9998 24.7797C36.9998 19.4871 35.1474 15.1965 32.8622 15.1965Z",
    fill: "#FF882F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5897_10596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics2);
export default __webpack_public_path__ + "static/media/statistics2.db28eb82dba829013e70ccd240aa8bfc.svg";
export { ForwardRef as ReactComponent };